export default "__VITE_ASSET__Cg5S9Shm__"